<wdx-list [vertical]="rows">
    @for (listItem of idList; track $index) {
        <li wdxListItem>
            {{ listItem.id }}
            @if (listItem.name) {
                <div wdxListItemSub>({{ listItem.name }})</div>
            }
            @if (listItem.isLocked) {
                <wdx-icon wdxListItemIcon [icon]="ICON_LOCK"></wdx-icon>
            }
        </li>
    }
</wdx-list>
